import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import commonReducer from '../reducers/commonSlice';
import authSlice from '../pages/auth/reducers/authSlice';
import casesReducer from '../pages/Cases/reducers/CasesSlice';
import notificationsSlice from '../reducers/notificationsSlice';
import CaseDetailSlice from '../pages/CaseDetails/reducers/caseDetailSlice';
import CaseHistoryDetailSlice from '../reducers/caseHistorySlice';
import feedbackSlice from 'src/pages/CaseDetails/feedbackForm/reducer/feedbackSlice';
import leaderboardSlice from 'src/reducers/leaderboardSlice';
import humanReminderSlice from 'src/reducers/humanReminderSlice';
import performanceDashboardSlice from 'src/pages/PerformanceDashboard/reducers/performanceDashboardSlice';

import storage from 'redux-persist/lib/storage';
import { persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import TeamLeadSlice from 'src/reducers/TeamLeadSlice';
import LiveLocationTrackerSlice from 'src/pages/LiveLocationTracker/reducers/LiveLocationTrackerSlice';
import reallocationSlice from 'src/pages/Reallocation/reducers/reallocationSlice';
import AgentAvailabilitySlice from 'src/pages/AgentAvailability/reducers';
import LeaveManagementSlice from 'src/pages/LeaveManagement/reducers/LeaveManagementSlice';
import agencyPincodeMappingSlice from '../reducers/agencyPincodeMappingSllice';
import ameyoUtilitySlice from '../pages/AmeyoUtility/reducer/ameyoUtilitySlice';

import whatsappChatbotSlice from '../reducers/whatsappChatbotSlice';
import TeleSenseiSlice from '@cp/src/pages/SenseiTele/reducer';
import Sensei from '../pages/sensei/reducers';
import ExternalDashboardSenseiSlice from 'src/pages/ExternalDashboardSensei/reducers/ExternalDashboardSenseiSlice';
import CsaTicketingSlice from 'src/pages/CsaTicketing/reducers/CsaTicketingSlice';
import ameyoSlice from '@cp/reducers/ameyoSlice';
import CaseAllocationSlice from '../pages/MapAllocationView/reducers/CaseAllocationSlice';
import CsaCoordinationSlice from '../pages/CsaCoordination/reducers/CsaCoordinationSlice';
import longhornThemeSlice from '../pages/LonghornTheme/longhornThemeSlice';
import uploadHistorySlice from '../pages/AllAgents/UploadHistory/reducers/uploadHistorySlice';
import allocationUploadHistorySlice from '../pages/AllocationServices/UploadHistory/allocationUploadHistorySlice';
import ParamountSlice from 'src/pages/Paramount/reducer';
import DocumentsSlice from '@cp/pages/CaseDetails/components/AllDocumentsV2/documentsSlice';
import bankStatementSlice from '../pages/CaseDetails/components/AllDocuments/reducer/bankStatementSlice';
import agentDocumentSlice from '../reducers/agentDocumentSlice';
import EnachSlice from '../pages/Enach/EnachUploadHistory/EnachSlice';
import CsaPerformanceDashboardSlice from '../pages/CsaPerformanceDashboard/reducers/CsaPerformanceDashboardSlice';
import AgencyDetailsSlice from '../reducers/AgencyDetailsSlice';
import agencyAllocationUploadHistorySlice from '../pages/AllocationServices/UploadHistory/agencyAllocationUploadHistorySlice';
import agencyCappingSlice from '@cp/reducers/agencyCappingSlice';
import AnomalyTrackerSlice from '../pages/AnomalyTracker/reducers/AnomalyTrackerSlice';
import ApprovalsSlice from '../pages/Approvals/reducers/ApprovalsSlice';
import FieldAllocationSlice from '../pages/FieldAllocations/reducers/FieldAllocationSlice';
import uploadAddressHistorySlice from '../pages/AddressIngestion/reducer/uploadHistorySlice';
import telePerformanceDashboardSlice from '../pages/TelePerformanceDashboard/reducer';
import CaseRecommendationSlice from '../pages/CaseRecommendation/reducer';
import visitPlanSlice from '../pages/VisitPlan/reducer/VisitPlanSlice';
import configureReportsSlice from '../reducers/configureReportsSlice';
import allocationSlice from '../reducers/allocationSlice';
import ciuAllocationsSlice from '../pages/CiuAllocations/ciuAllocationSlice';
import callAuditSlice from '../pages/CallAudit/callAuditSlice';
import callLimitSlice from '../pages/CallLimit/reducer/callLimitSlice';

export const reducer = combineReducers({
  common: commonReducer,
  allCases: casesReducer,
  notification: notificationsSlice,
  auth: authSlice,
  caseDetail: CaseDetailSlice,
  feedBack: feedbackSlice,
  leaderboard: leaderboardSlice,
  humanReminder: humanReminderSlice,
  performanceDashboard: performanceDashboardSlice,
  caseHistoryDetail: CaseHistoryDetailSlice,
  approvals: ApprovalsSlice,
  reallocation: reallocationSlice,
  teamLeadDashboard: TeamLeadSlice,
  agencyDashboard: AgencyDetailsSlice,
  liveLocationTracker: LiveLocationTrackerSlice,
  externalDashboardSensei: ExternalDashboardSenseiSlice,
  caseAllocation: CaseAllocationSlice,
  agentAvailabilitySlice: AgentAvailabilitySlice,
  leaveManagement: LeaveManagementSlice,
  agencyPincodeMapping: agencyPincodeMappingSlice,
  agencyCapping: agencyCappingSlice,
  ameyoUtility: ameyoUtilitySlice,
  uploadHistory: uploadHistorySlice,
  agencyAllocationUploadHistory: agencyAllocationUploadHistorySlice,
  allocationUploadHistory: allocationUploadHistorySlice,
  whatsappChatbot: whatsappChatbotSlice,
  teleSensei: TeleSenseiSlice,
  sensai: Sensei,
  ameyoSlice: ameyoSlice,
  csaTicketing: CsaTicketingSlice,
  csaCoordination: CsaCoordinationSlice,
  longhornTheme: longhornThemeSlice,
  paramountSlice: ParamountSlice,
  enachSlice: EnachSlice,
  bankStatementSlice: bankStatementSlice,
  agentDocumentSlice: agentDocumentSlice,
  documentSlice: DocumentsSlice,
  csaPerformanceDashboard: CsaPerformanceDashboardSlice,
  anomalyTracker: AnomalyTrackerSlice,
  telePerformanceDashboard: telePerformanceDashboardSlice,
  visitPlan: visitPlanSlice,
  uploadAddressHistory: uploadAddressHistorySlice,
  fieldAllocation: FieldAllocationSlice,
  caseRecommendation: CaseRecommendationSlice,
  configureReport: configureReportsSlice,
  allocations: allocationSlice,
  ciuAllocations: ciuAllocationsSlice,
  callAudit: callAuditSlice,
  callLimit: callLimitSlice
});

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['humanReminder', 'ameyoSlice', 'visitPlan']
};
const persistedReducer = persistReducer(persistConfig, reducer);
export const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
      }
    })
});

export default store;
export type RootState = ReturnType<typeof store.getState>;
